/* eslint-disable no-nested-ternary */
import React from 'react';
import { Reorder, motion } from 'framer-motion';
import { colorPalette } from '@lib/constants';
import { parseColorToRgba } from '@services/interactions-service';

const FantasticFansItem = ({
  fans,
  colors,
  animatedCount,
  animatedRelativePercentage
}) => {
  return (
    <div className="w-full inline-flex flex-col justify-start items-start gap-4">
      {fans.map(({ id, commenterName }, index) => (
        <Reorder.Item
          key={id}
          value={id}
          style={{ backgroundColor: parseColorToRgba(colors?.fantasticFansChartColor || '#F97B5F', 0.4) }}
          className="relative w-full h-20 flex items-center rounded-[50px] transition-all overflow-hidden"
          layout
          transition={{ type: 'spring', stiffness: 40, damping: 20 }}
        >

          <motion.div
            style={{ backgroundColor: parseColorToRgba(colors?.fantasticFansChartColor || '#F97B5F', 1) }}
            className="h-20 p-2.5 rounded-tl-[50px] rounded-bl-[50px]"
            initial={{ width: 0 }}
            animate={{
              width: `${animatedRelativePercentage[id]}%`,
            }}
            transition={{ duration: 1.2, ease: 'easeOut' }}
          />

          {/* Left section with avatar */}
          <div className="absolute top-1/2 transform -translate-y-1/2 flex items-center gap-4">
            <div
              className="w-20 h-20 rounded-[50px] flex justify-center items-center"
              style={{ backgroundColor: colorPalette[index % colorPalette.length] }}
            >
              <div className="text-[#212121] text-3xl font-semibold leading-[34.50px]">
                {commenterName?.charAt(0)}
              </div>
            </div>
            <div
              style={{
                color: parseColorToRgba(colors?.fantasticFansChartColor || '#F97B5F', 1) === parseColorToRgba(colors?.ffTextColor || '#000000', 1)
                  ? '#000000'
                  : (colors?.ffTextColor || '#000000')
              }}
              className='text-3xl font-normal leading-[48px] max-w-4xl line-clamp-1'>
              {commenterName}
            </div>
          </div>

          {/* Right section with count */}
          <div className="absolute right-[24px] top-1/2 transform -translate-y-1/2 flex justify-start items-center gap-4">
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              style={{
                color: parseColorToRgba(colors?.fantasticFansChartColor || '#F97B5F', 1) === parseColorToRgba(colors?.ffTextColor || '#000000', 1)
                  ? '#000000'
                  : (colors?.ffTextColor || '#000000')
              }}
              className='text-3xl font-normal leading-[48px]'>
              {animatedCount[id]}
            </motion.div>
          </div>
        </Reorder.Item>
      ))}
    </div>
  );
};

export default FantasticFansItem;
